// extracted by mini-css-extract-plugin
export default {"boundaries":"styles_boundaries__YtfYE","saveIcon":"styles_saveIcon__qazLo","name":"styles_name__izHXS"};